(function ($) {
  DJ.addBehavior('userPageSummary', '.user-page', {
    attach: function () {
      const titles = $('h3', $(this));
      let content = '';
      let lastScroll = 0;

      titles.each((i, heading) => {
        const id = `summary-item-${i}`;
        $(heading).attr('id', id);
        content += `<a href="#${id}">${heading.innerText}</a>`;
      });
      // Make highlights for summary navigation.
      const highlightSummary = ($sections, $links) => {
        const scrollTop = $(window).scrollTop() + 90;
        for (let i = $sections.length - 1; i >= 0; i -= 1) {
          const $section = $sections.eq(i);
          const $parent = $links.parent();
          if (scrollTop >= $section.offset().top) {
            $parent.removeClass('active');
            $links.removeClass('active');

            return $links
              .removeClass('active')
              .filter(`[href="#${$section.attr('id')}"]`)
              .addClass('active')
              .parent()
              .addClass('active');
          }

          // Remove active state from first items when user scrolls up.
          if (lastScroll > scrollTop && scrollTop < $section.offset().top && i === 0) {
            $links.removeClass('active');
            $parent.removeClass('active');
          }
        }

        lastScroll = scrollTop;

        return true;
      };

      $('.summary').append(content);

      const summaryLink = $('.summary a');

      summaryLink.click((e) => {
        e.preventDefault();

        $('html, body').animate({
          scrollTop: $($(e.currentTarget).attr('href')).offset().top - 70,
        }, 500);
      });

      highlightSummary(titles, summaryLink);
      $(window).scroll(() => {
        highlightSummary(titles, summaryLink);
      });
    }
  });
})(jQuery);
